// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Gt9I","list":"styles_list__2FOT7"};